module.exports = __webpack_public_path__ + "static/l4-93756717034270ab660c9c8fe3306760.png";